import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BrowserInterface } from '@core/interfaces/browser.interface';
import { BrowserService } from '@core/services/browser/browser.service';
import { GoogleAnalitycsService } from '@core/services/google-analitycs/google-analitycs.service';
import { MessageBusService, MicroFrontendRouter } from '@xdig/ng-microkernel/micro-frontend';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { Subject } from 'rxjs';
import { takeUntil, tap, map, distinctUntilChanged } from 'rxjs/operators';
@Component({
  selector: 'shell-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterViewInit, OnDestroy {
  private destroy$ = new Subject<void>();
  urlInicio = '/inicio';
  constructor(
    private messageBus: MessageBusService,
    private microFrontendRouter: MicroFrontendRouter,
    private gtmService: GoogleTagManagerService,
    private googleAnalitycSrv: GoogleAnalitycsService,
    private browserService: BrowserService,
    private router: Router,
  ) {}

  ngAfterViewInit(): void {
    this.getBrowserName();
    this.onRouting();
    this.onGoogleTagManagerPages();
    this.onGoogleTagManagerEvents();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onGoogleTagManagerPages(): void {
    // Obtener la ruta enviada a través del BUS.
    const gtmPathBus$ = this.messageBus.on$<string>('shell', 'google-tag-manager.path');

    gtmPathBus$
      .pipe(
        takeUntil(this.destroy$),
        distinctUntilChanged((p: any, q: any) => p.pageName === q.pageName),
        map((data: any) => ({ page_location: data.pageName, page_title: data.pageTitle })),
        tap((gtmTag) => this.googleAnalitycSrv.trackPage(gtmTag)),
      )
      .subscribe();
  }

  onGoogleTagManagerEvents(): void {
    this.messageBus
      .on$<object>('shell', 'google-tag-manager.event')
      .pipe(
        takeUntil(this.destroy$),
        tap((gtmTag) => this.gtmService.pushTag(gtmTag)),
      )
      .subscribe();

    this.messageBus
      .on$<string>('shell', 'google-tag-manager.conversion')
      .pipe(
        takeUntil(this.destroy$),
        tap((gtmConversion) => {
          this.googleAnalitycSrv.trackConversion(gtmConversion);
        }),
      )
      .subscribe();

    this.messageBus
      .on$<string>('shell', 'google-tag-manager.conversion-USD')
      .pipe(
        takeUntil(this.destroy$),
        tap((gtmConversion) => {
          this.googleAnalitycSrv.trackConversionUSD();
        }),
      )
      .subscribe();
  }

  onRouting(): void {
    this.messageBus
      .on$<[string, string]>('shell', 'navigate')
      .pipe(
        takeUntil(this.destroy$),
        tap(([url]) => {
          if (url === this.urlInicio) {
            this.messageBus.emit('shell', 'footer.type', 'HOME');
          } else {
            this.messageBus.emit('shell', 'footer.type', 'DEFAULT');
          }
        }),
        tap(([url, microappId]) => this.microFrontendRouter.navigateByUrl(url, microappId)),
      )
      .subscribe();
  }

  //Get browser config.
  getBrowserName() {
    const browserName = this.browserService.getBrowserName();
    this.messageBus.emit<BrowserInterface>('shell', 'browser.info', { name: browserName });
  }
}
